<template>
	<report-panel :anchor="anchor" :styling="'background-color:#c3d8d8;'">
		<div slot="title">Company Details</div>
		<div slot="body">
			<table class="table table-striped" id="company-details-table">
				<tbody>
				<tr>
					<th scope="row">Company Name:</th>
					<td>
						{{ companyOverview.company_name }}
					</td>
				</tr>
				<tr>
					<th scope="row">Company Registration Number:</th>
					<td>
						{{ companyOverview.registration_number }}
					</td>
				</tr>
				<tr>
					<th scope="row">Company Type:</th>
					<td>
						{{ companyTypeName }}
					</td>
				</tr>
				<tr>
					<th scope="row">Company Status:</th>
					<td>
						<span class="label"
							  :class="'label-' + companyOverviewStatusLabelClass">
							{{ simpleStatusName }}
						</span>
					</td>
				</tr>
				<tr>
					<th scope="row">Date Incorporated:</th>
					<td>
						{{ formatDate(companyOverview.incorporated_date) }}
						({{ formatAge(companyOverview.company_age_in_years, 'years') }})
					</td>
				</tr>
				<tr>
					<th scope="row">Number Of Active Directors:</th>
					<td>
						{{ numberOfActiveDirectors }}
						active director<span v-if="numberOfActiveDirectors != 1">s</span>.
					</td>
				</tr>
				<tr>
					<th scope="row">Number of Potential Sanction Matches:</th>
					<td>
						<template v-if="companyOverview.report && companyOverview.report.includes_sanctions">
							<span v-if="numberOfSanctions > 0"  class="fas fa-exclamation-triangle hse-warning" />
							{{ numberOfSanctions }} sanction
							match<span v-if="numberOfSanctions !== 1">es</span>
							found.
						</template>
						<template v-else>
							Sanction data unavailable when data collected.
						</template>
					</td>
				</tr>

				</tbody>
			</table>
			<div class="subtext">
				Data collected:&nbsp;{{ formatDate(companyOverview.created_at) }}
			</div>
		</div>
	</report-panel>
</template>

<script>
import CompaniesTools from '@/components/companies/Tools';
import GeneralTools from '@/mixins/GeneralTools';
import ReportPanel from '@/components/reports/components/ReportPanel';

export default {
  components: {
    ReportPanel,
  },
  computed: {
    companyTypeName() {
      if (this.companyOverview.companytype !== undefined) {
        return this.companyOverview.companytype.name;
      }
      return 'N/A';
    },
    simpleStatusName() {
      if (this.companyOverview && this.companyOverview.simplestatus) {
        return this.companyOverview.simplestatus.name;
      }
      return 'N/A';
    },
  },
  mixins: [CompaniesTools, GeneralTools],
  name: 'CompanyDetails',
  props: {
    anchor: {
      default: null,
      required: false,
      type: String,
    },
    companyOverview: {
      required: true,
      type: Object,
    },
  },
};
</script>
